import styles from "./styles/Loading.module.scss";

export default function Loading({ style = {} }) {
    return (
        <div className={styles["lds-ring"]} style={style}><div></div><div></div><div></div><div></div></div>
    )
}
